<template>
    <div class="row ai-log-line border rounded m-1">
        <div class="col-1">
            <div>{{ data.id }}</div>
            <div>{{  data.InsDate }}</div>
            <div>Статус: {{  data.status }}</div>
            <div>{{  data.UpdDate }}</div>
            <div>ТПС: {{ data.tps }}</div>
        </div>
        <div class="col-4 prewrap">
             {{ data.payload }}
        </div>
        <div class="col-3 prewrap">
            {{  drawJson(data.prompt) }}
        </div>
        <div class="col-4 prewrap" v-if="data.answer">
            {{ data.answer }}
        </div>
        <div v-else class="col-4 prewrap">
            {{  drawJson(data.answer_raw)}}
        </div>
    </div>
</template>
<script>
export default{
    props:{
        data:{ type: Object, required:true}
    },
    methods:{
        drawJson(json){
            try{
                return JSON.stringify(JSON.parse(json), null, 2);
            }catch(e){
                return json
            }
        }
    }
}
</script>
<style lang="scss">
.ai-log-line{
    div.prewrap{
        overflow-y: auto;
        max-height: 75vh;
    }
}
</style>